module.exports = __webpack_public_path__ + "media/fonts/materialdesignicons-webfont-d8e8e0f7931afa097409dbb0ea7815d8.woff";